import React, { useMemo, useState } from 'react';
import { FormControl, Grid, InputAdornment, TextField } from '@mui/material';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import { I_Installation } from '../../../interfaces/InstallationTypes';
import { Route, Routes, useLocation } from 'react-router-dom';
import routes from '../../../Resources/routes.json';
import FlatInstallationView from './FlatInstallationView';
import SodioHomeInstallation from './Installation';

interface installationSearchProps {
  installations: I_Installation[];
}

function InstallationSearch(props: installationSearchProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const currentLocation = useLocation();
  // const [filteredData, setFilteredData] = useState(props.installations);

  const indexedData = useMemo(() => {
    return props.installations.map((item) => ({
      ...item,
      nameLower: item.name.toLowerCase(),
      locationLower: item.location.toLowerCase(),
      regionLower: item.region.toLowerCase()
    }));
  }, [props.installations]);

  const filteredData = useMemo(() => {
    return indexedData.filter(
      (item) =>
        item.nameLower.includes(searchTerm.toLowerCase()) ||
        item.locationLower.includes(searchTerm.toLowerCase()) ||
        item.regionLower.includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, indexedData]);

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display:
              currentLocation.pathname ===
                routes.sodiohome_installations + 'list' ||
              currentLocation.pathname ===
                routes.sodiohome_installations + routes.list
                ? 'block'
                : 'none'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start'
            }}
          >
            <FormControl variant="outlined">
              <TextField
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchTwoToneIcon />
                    </InputAdornment>
                  )
                }}
              />
            </FormControl>
          </div>
        </Grid>
      </Grid>

      <FlatInstallationView installations={filteredData} />
      <Routes>
        {filteredData.map((installation) => {
          return (
            <Route
              key={installation.id}
              path={routes.installation + installation.id + '/*'}
              element={
                <SodioHomeInstallation
                  key={installation.id}
                  current_installation={installation}
                  type="installation"
                ></SodioHomeInstallation>
              }
            />
          );
        })}
      </Routes>
    </>
  );
}

export default InstallationSearch;
